import type { PayloadAction } from '@reduxjs/toolkit';
import type { CampaignEditorReducerCreator } from '../types';
import { updateBlock } from '../helpers';

// content props (not style): spacer height and the like live here because that is where the
// templates and default blocks author them. undefined clears the key back to the block default.
const updateBlockProp = (create: CampaignEditorReducerCreator) =>
  create.reducer((state, action: PayloadAction<{ blockId: string; key: string; value: unknown }>) => {
    const { blockId, key, value } = action.payload;
    updateBlock(state, blockId, (block) => {
      const nextProps = { ...block.props, [key]: value };
      if (value === undefined) delete nextProps[key];
      return { ...block, props: nextProps };
    });
  });

export default updateBlockProp;
